import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=a9f83e54&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=a9f83e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports